import React, { Component } from 'react'
import { Button, Col, Container, Form, Image, InputGroup, Row, Nav } from "react-bootstrap";
import { connect } from 'react-redux'
import { AppState } from "../AppState";
import { Action, Dispatch } from "redux";
import { AppPageWrapper } from "../components/NavMenu/AppPageWrapper";
import logoImage from "../assets/images/logo.png"
import { loginToWorkforce } from "../actions/WorkforceOneLoginActions";
import ForgotPassword from "../components/Secuirty/ForgotPassword";
import { FaEye, FaEyeSlash } from "react-icons/fa"
import { LoginNavMenu } from "../components/NavMenu/LoginNavMenu"
import { Home } from "../config/Routes"
import { ApiRootUrl } from "../api/ApiUrl"
import { NotificationPanel } from "../components/Notification/NotificationPanel"

export interface Workforce1LoginProps {
  test?: boolean
}
export interface Workforce1LoginAppStateProps {
  foundToken: boolean
}
export interface Workforce1LoginDispatchProps {
  login: (username: string, password: string) => void
}
export interface Workforce1LoginState {
  username: string
  password: string
  showPass: boolean
  inputType: string
}
export class Workforce1Login extends Component<Workforce1LoginProps & Workforce1LoginAppStateProps & Workforce1LoginDispatchProps, Workforce1LoginState>{
  state: Workforce1LoginState = {
    username: "",
    password: "",
    showPass: false,
    inputType: "password",
  }
  login = (e: React.FormEvent) => {
    localStorage.removeItem("portalImage");
    localStorage.removeItem("consortiumCheckCompanies");
    e.preventDefault()
    const userName = this.state.username.trim();
    const password = this.state.password;
    this.props.login(userName, password);
  }

  toggleShowPass = () => {
    this.setState({ showPass: !this.state.showPass, inputType: this.state.showPass ? "password" : "text" })
  }

  render() {
    const colProps = { lg: { span: 8, offset: 2 }, xl: { span: 6, offset: 3 } }
    return <AppPageWrapper showNav={false} hideLogo={true} showSupportedBrowsers={true}>
      <Container fluid>
        <Form onSubmit={this.login} >
          <Row>
            <Col {...colProps}><Image className="mx-auto d-block m-4" src={logoImage} alt="CRL OnTrack" fluid /></Col>
          </Row>
          <Row>
            <Col {...colProps}>
              <LoginNavMenu active={Home} />
            </Col>
          </Row>
        <Row>
          <Col {...colProps}>
            <Form.Group controlId="formBasicEmail">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text className="fixed-w6_2">Username</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control onChange={(e) => { this.setState({ username: e.target.value }) }} value={this.state.username} type="text" />
              </InputGroup>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col {...colProps}>
            <Form.Group controlId="formBasicPassword">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text className="fixed-w6_2">Password</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control onChange={(e) => { this.setState({ password: e.target.value }) }} value={this.state.password} type={this.state.inputType} />
                <InputGroup.Append onClick={this.toggleShowPass}>
                  <InputGroup.Text className="bg-transparent">
                    {this.state.showPass && <FaEye />}
                    {!this.state.showPass && <FaEyeSlash />}
                  </InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col {...colProps}>
            <Form.Group className="text-center">
              <ForgotPassword userName={this.state.username} />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col {...colProps}>
            <Button block={true} variant="primary" type="submit">
              Log In
                </Button>
          </Col>
        </Row>
        <Row>
          <Col {...colProps}>
            <NotificationPanel />
            <div className="mt-4">
              <small>Access and use of this website is restricted to authorized users 
                (who have agreed to be bound by all the terms, requirements and conditions in  <a href={ApiRootUrl() + "/Template/FFOrderDocs.pdf"} target="_blank">FormFox's Website Access License</a>).
                 Unauthorized users should exit immediately to avoid possible civil or criminal liability. 
                 Unauthorized access to this facility, copying or any other reproduction of materials from this system is prohibited.</small>
            </div>
          </Col>
        </Row>
          </Form>
        </Container>
      </AppPageWrapper >
    }
}
function mapStateToProps(state: AppState): Workforce1LoginAppStateProps {
  return {
    foundToken: !!state.Workforce1State.webToken
  }
}
function mapDispatchProps(dispatch: Dispatch<Action>): Workforce1LoginDispatchProps {
  return {
    login: (username: string, password: string) => (dispatch(loginToWorkforce(username, password))),
  }
}
const connector = connect<Workforce1LoginAppStateProps, Workforce1LoginDispatchProps, Workforce1LoginProps, AppState>(
  mapStateToProps, mapDispatchProps)(Workforce1Login);
export default connector;
